export enum HistoryType {
    QUOTATION = 1,
    SOLUTION = 2,
}